// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X4ix","colMin":"styles_colMin__L0_2s"};